// removed by extract-text-webpack-plugin
module.exports = {"modalHeader":"successModal__modalHeader__1RSwy","modalBody":"successModal__modalBody__3n4jk","modalContent":"successModal__modalContent__8MaNA"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/contact/shared/styles/successModal.scss
// module id = 871
// module chunks = 4 6 8 9 17